import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { UseFormReturn } from "react-hook-form";
import styles from "./SuccessPlanWorkflow.module.scss";
import { Button, Typography } from "@mui/material";
import {
  HistoryListRenderer,
  RiskSelectController,
  TinyMCEController,
  useSpContext,
} from "components/summary/success-plan";
import { useState } from "react";
import MButton from "components/momentum/MButton";

type EpsmPartnerAssessmentStepProps = {
  spState: SuccessPlanState;
  form: UseFormReturn<any>;
};

const EpsmPartnerAssessmentStep = ({ spState, form }: EpsmPartnerAssessmentStepProps) => {
  const { riskItems } = useSpContext();
  const { control, setValue } = form;

  const { spData } = spState;
  const histories = spData.histories || [];
  const [togglePreviousNotes, setTogglePreviousNotes] = useState(false);

  const noteHistories = histories.filter((history: any) => history.fieldName === "epsmRiskNote");
  const handleTogglePreviousNotes = () => {
    setTogglePreviousNotes(!togglePreviousNotes);
  };

  const handleCopyNote = (fieldName: string, noteContent: string) => {
    setValue(fieldName, noteContent);
  };

  const latestNote =
    noteHistories.length && noteHistories.length > 0 ? noteHistories[0].newValue : "";

  return (
    <div className={styles["step-wrapper"]}>
      <div className={styles["grid-two-lane"]}>
        <div className={styles["form-field-wrapper"]}>
          <Typography className={styles["form-field-label"]}>EPSM Partner Assessment:</Typography>
        </div>
        <RiskSelectController
          control={control}
          name="epsmRisk"
          riskItems={riskItems}
        />

        <div className={`${styles["form-field-wrapper"]} ${styles["grid-column-span-2"]}`}>
          <Typography className={styles["form-field-label"]}>
            Explain why the risk is assessed at this level:
          </Typography>
        </div>
        <div className={styles["grid-column-span-2"]}>
          <TinyMCEController
            name="epsmRiskNote"
            control={control}
          />
        </div>

        {noteHistories.length > 0 && (
          <div className={`${styles["flex-space"]} ${styles["grid-column-span-2"]}`}>
            <MButton
              buttonType="blue"
              onClick={() => handleCopyNote("epsmRiskNote", latestNote)}
            >
              Copy Previous Note
            </MButton>
            <Button
              onClick={handleTogglePreviousNotes}
              disableRipple
              disableTouchRipple
              disableFocusRipple
              sx={{
                textTransform: "none",
                ":hover": { backgroundColor: "transparent" },
                fontSize: "12px",
              }}
            >
              {togglePreviousNotes ? "Hide Previous Notes" : "View Previous Notes"}
            </Button>
          </div>
        )}
        <div className={`${styles["grid-column-span-2"]} ${styles["flex-vertical-gap"]}`}>
          {togglePreviousNotes && <HistoryListRenderer noteHistories={noteHistories} />}
        </div>
      </div>
    </div>
  );
};

export default EpsmPartnerAssessmentStep;
